<template>
    <article class="content">
        <h1 class="title">Contact us</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique mollitia, fugit facilis. Eaque, excepturi quod impedit ullam dolor, laboriosam deserunt.</p>
        <div class="icon-text">
            <span class="icon has-text-success is-medium">
                <span class="iconify" data-icon="la:location-arrow" data-inline="false" style="font-size: 1.7rem;"></span>
            </span>
            <span> E 71 8th Ave, US</span>
        </div>
       
        <div class="icon-text">
            <span class="icon has-text-success is-medium">
                <span class="iconify" data-icon="la:mobile" data-inline="false" style="font-size: 1.7rem;"></span>
            </span>
            <span> 123-456-789</span>
        </div>
       
        <div class="icon-text">
            <span class="icon has-text-success is-medium">
                <span class="iconify" data-icon="topcoat:email" data-inline="false" style="font-size: 1.3rem;"></span>
            </span>
            <span>email@domain.com</span>
        </div>
       
        <div class="icon-text">
            <span class="icon has-text-success is-medium">
                <span class="iconify" data-icon="ion:earth" data-inline="false" style="font-size: 1.3rem;"></span>
            </span>
            <span>www.domain.com</span>
        </div>
       
    </article>
</template>
<script>
export default {
    name: 'contact',

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iconify{

}
.icon-text{
	margin-top: .5rem;	
	color:black;
}

</style>